function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { WidevineSecurityLevel } from '../core/player/video-format';
var H264_PROFILE_BASE = 'video/mp4; codecs="avc1.42E01E"';
var ROBUSTNESS_TO_LEVEL_MAP = {
    SW_SECURE_CRYPTO: WidevineSecurityLevel.L3,
    SW_SECURE_DECODE: WidevineSecurityLevel.L3,
    HW_SECURE_CRYPTO: WidevineSecurityLevel.L2,
    HW_SECURE_DECODE: WidevineSecurityLevel.L1,
    HW_SECURE_ALL: WidevineSecurityLevel.L1
};
var ORDERED_ROBUSTNESS_LEVELS = [
    'HW_SECURE_ALL',
    // Widevine L1
    'HW_SECURE_DECODE',
    // Widevine L1
    'HW_SECURE_CRYPTO',
    // Widevine L2
    'SW_SECURE_DECODE',
    // Widevine L3
    'SW_SECURE_CRYPTO'
];
// Widevine L3
function robustnessToLevel(robustness) {
    var _ROBUSTNESS_TO_LEVEL_MAP_robustness;
    return (_ROBUSTNESS_TO_LEVEL_MAP_robustness = ROBUSTNESS_TO_LEVEL_MAP[robustness]) !== null && _ROBUSTNESS_TO_LEVEL_MAP_robustness !== void 0 ? _ROBUSTNESS_TO_LEVEL_MAP_robustness : WidevineSecurityLevel.UNKNOWN;
}
function getMediaKeySystemConfigFor(robustness) {
    return [
        {
            videoCapabilities: [
                {
                    contentType: H264_PROFILE_BASE,
                    robustness: robustness
                }
            ]
        }
    ];
}
export function getWidevineSecurity() {
    return _getWidevineSecurity.apply(this, arguments);
}
function _getWidevineSecurity() {
    _getWidevineSecurity = _async_to_generator(function() {
        var context, result;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    context = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : self;
                    result = {
                        securityLevel: WidevineSecurityLevel.UNKNOWN
                    };
                    return [
                        4,
                        getWidevineRobustnessLevel(context)
                    ];
                case 1:
                    result.robustnessLevel = _state.sent();
                    if (result.robustnessLevel) {
                        result.securityLevel = robustnessToLevel(result.robustnessLevel);
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _getWidevineSecurity.apply(this, arguments);
}
function getWidevineRobustnessLevel() {
    return _getWidevineRobustnessLevel.apply(this, arguments);
}
function _getWidevineRobustnessLevel() {
    _getWidevineRobustnessLevel = _async_to_generator(function() {
        var context, videoRobustness, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, level, err, err1;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    context = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : self;
                    videoRobustness = undefined;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    _iterator = ORDERED_ROBUSTNESS_LEVELS[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        7
                    ];
                    level = _step.value;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    // eslint-disable-next-line no-await-in-loop -- Specifically want to check each level here individually, not in parallel.
                    return [
                        4,
                        context.navigator.requestMediaKeySystemAccess('com.widevine.alpha', getMediaKeySystemConfigFor(level))
                    ];
                case 4:
                    _state.sent();
                    videoRobustness = level;
                    return [
                        3,
                        7
                    ];
                case 5:
                    err = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    err1 = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err1;
                    return [
                        3,
                        10
                    ];
                case 9:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 10:
                    // noop
                    return [
                        2,
                        videoRobustness
                    ];
            }
        });
    });
    return _getWidevineRobustnessLevel.apply(this, arguments);
}

//# sourceMappingURL=widevine-utils.js.map